import api from "./api";
import endpoints from "./endpoints";

export default {
  getSmartSnippets: async function (language, articleId, inherits) {
    const response = await api.get(endpoints.smartSnippets.get, {
      params: { language, articleId, inherits }
    });
    return response.data;
  },
  resolvedSmartSnippet: async function (language, articleId, text) {
    const response = await api.post(endpoints.smartSnippets.resolved.get, text, {
      params: { language, articleId },
      headers: { "Content-Type": "application/json" }
    });
    return response.data;
  }
};
